import { FormControlLabel, Switch } from "@mui/material";
import React, { FC } from "react";

import { parseBoolean, PrimitiveType } from "@ryde/shared";

interface ISwitch {
  id?: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?:
    | ((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void)
    | undefined;
  label?: string;
  width?: string;
  e2eData?: string;
}

const switchAnyValueToBool = (val: PrimitiveType): boolean => {
  return val === true || val === "on" || parseBoolean(val) || false;
};

export const MuiSwitch: FC<ISwitch> = ({
  checked,
  disabled,
  onChange,
  id,
  label,
  e2eData,
}) => {
  return (
    <FormControlLabel
      disabled={disabled}
      control={
        <Switch
          id={id}
          checked={switchAnyValueToBool(checked)}
          data-e2e-value={switchAnyValueToBool(checked)}
          data-e2e={e2eData || ""}
          disabled={disabled}
          onChange={onChange}
        />
      }
      label={label}
    />
  );
};
